module.exports = __webpack_public_path__ + "static/media/NunitoSans-Bold.3877b2d5.woff";